__turbopack_context__.v({
  "afisha-selection-chevron--big": "MediaCardCompilation-module-sass-module__X38BJG__afisha-selection-chevron--big",
  "afisha-selection-chevron--medium": "MediaCardCompilation-module-sass-module__X38BJG__afisha-selection-chevron--medium",
  "button": "MediaCardCompilation-module-sass-module__X38BJG__button",
  "card": "MediaCardCompilation-module-sass-module__X38BJG__card",
  "favorite": "MediaCardCompilation-module-sass-module__X38BJG__favorite",
  "image": "MediaCardCompilation-module-sass-module__X38BJG__image",
  "image-wrapper": "MediaCardCompilation-module-sass-module__X38BJG__image-wrapper",
  "numbers": "MediaCardCompilation-module-sass-module__X38BJG__numbers",
  "promo": "MediaCardCompilation-module-sass-module__X38BJG__promo",
  "skeleton-card": "MediaCardCompilation-module-sass-module__X38BJG__skeleton-card",
  "skeleton-inner": "MediaCardCompilation-module-sass-module__X38BJG__skeleton-inner",
  "title": "MediaCardCompilation-module-sass-module__X38BJG__title",
});
